import React from "react";
import Styled from "styled-components";
import { HiCollection } from "react-icons/hi";
const NoItem = Styled.div`
    border: 2px dashed #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    color: #d1d1d1;
    flex-direction: column;
`;
const NoIcon = Styled.div`
    font-size: 4rem;
    color: #e0e0e0;
`;
const NoText = Styled.div`
    font-size: 1.5rem;
    font-weight: 600;
`;
const NoItemFound = ({ props }) => {
  const message = props?.message ? props.message : "No events found";

  return (
    <NoItem>
      <NoIcon>
        <HiCollection />
      </NoIcon>
      <NoText>{message}</NoText>
    </NoItem>
  );
};

export default NoItemFound;
